// extracted by mini-css-extract-plugin
export default {"container":"GBottomSaveBar_container__cgs3m"};